<template>
  <div id="app" v-if="ifShow">
    <router-view />
  </div>
</template>

<script>
import {swapToken,getSwapToken} from '@/utils/value'
import { removeB,setFromHomePath} from '@/utils/cookies'
import { asyncSave } from "@/api/szts"
export default {
  name: "App",
  data(){
    return{
			ifShow: false,
      pathArr:[
        {pcPath: '/indexs',mPath:'/home'}, //首页
        {pcPath: '/commodity-details',mPath:'/mproductdetail'}, // 商品详情
        {pcPath: '/commodity-list',mPath:'/searchResult'}, // 搜索结果页
        {pcPath: '/jproom',mPath:'/mjpRoom'}, //精品库列表
        {pcPath: '/roomDetail',mPath:'/mjpDetails'}, //精品库详情
        {pcPath: '/mansion',mPath:'/libraryResources'}, //本馆资源列表
        {pcPath: '/myRecommend',mPath:'/alBought'}, //我的荐购
      ]
    }
  },
	mounted(){
    console.log('get swap token',getSwapToken())
    console.log(this.$route)
    console.log(window.location.href)
    if (getSwapToken()){
      if(window.location.href.indexOf('.com/home') > 0 || window.location.href.indexOf('.com/index') > 0){
        removeB() 
      }
    }
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
		  setTimeout(()=>{
		  	this.ifShow = true
		  },1000)
    }else{
      this.ifShow = true
    }
	},
  watch: {
    $route: {
      handler: function(to, from) {
        console.log('路径2333',to.fullPath)
        console.log('路径23334',to)
        let thePath = to.path
        let fullPath = to.fullPath
        console.log('to.namenamenamenamename',to,from)
        console.log('to.name',to,process.env.LIB_PLATFORM_PATH+to.path)
        let url = process.env.LIB_PLATFORM_PATH+to.path
        let name = to.meta.title
        if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          // return;
          this.getAsyncSave(url,name,'mweb')
        } else {
          this.getAsyncSave(url,name,'PC')
          // let pcPath = fullPath.replace(this.pathArr[i].mPath, this.pathArr[i].pcPath)
          // window.location.href = process.env.LIB_PLATFORM_PATH + pcPath
          // console.log('路径2333pc',pcPath)
        }
        console.log('路径23335',thePath)
        for(let i=0;i<this.pathArr.length;i++){
          if(thePath == this.pathArr[i].pcPath){
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
              let mPath = fullPath.replace(this.pathArr[i].pcPath, this.pathArr[i].mPath)
              window.location.href = process.env.LIB_PLATFORM_PATH + mPath
              console.log('路径2333m',mPath)
            } else {
              return;
            }
          }
          if(thePath == this.pathArr[i].mPath){
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
              return;
            } else {
              let pcPath = fullPath.replace(this.pathArr[i].mPath, this.pathArr[i].pcPath)
              window.location.href = process.env.LIB_PLATFORM_PATH + pcPath
              console.log('路径2333pc',pcPath)
            }
          }
        }
      

      }
    }
  },
  methods:{
    
    // visitLog/asyncSave
    getAsyncSave(url,name,platform){
      let params = {}
      let paramsBody = {
        appCode: 'sztsg',
        url: url,
        name: name,
        platform: platform
      }
      asyncSave(params,paramsBody).then(res=>{
        console.log('resresres',res.data)
      })
    },
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}

ul{ 
  list-style: none;
}
.clear::after{
  content: "";
  clear: both;
}

.st-w-1200 {
  position: relative;
  width: 1200px;
  margin: 0 auto;
}

.el-popper.home-search-dropdown {
  margin-top: 0;
  width: 72px;
  padding: 0;
  border: 1px solid #E1E1E1;
}
.home-search-dropdown .popper__arrow {
  display: none;
}
.home-search-dropdown li {
  padding: 0;
  text-align: center;
  width: 72px;
  height: 35px;
  margin: 0;
  line-height: 35px;
  padding: 0 12px;
  background-color: #f7f7f7;
}
.home-search-dropdown li:nth-child(1) {
  border-bottom: 1px solid #e1e1e1;
}
.home-search-dropdown .el-dropdown-menu__item--divided:before {
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue